import cn from "classnames";
import React, { useEffect, useState } from "react";
import { useTranslation } from "../../../utils/store/useTranslation";
import { useAuth } from "../../../utils/hooks/useAuth";
import { getUserChatHistories } from "../../../../services/zendesk.service";
import { IMoreHelpCard, MoreHelpCard } from "./MoreHelpCard";
import { trackUserEvent } from "~/lib/utils/analytics";
import { EVENT_CHANNELS, EVENT_TYPES } from "~/lib/utils/analytics.events";
import { autoStartChat } from "~/lib/utils/chatWIdget.events";

const FindMoreHelp = () => {
  const { loginState, profile } = useAuth();
  const { t } = useTranslation();
  const [isViewHistory, setIsViewHistory] = useState<boolean>(false);
  const isAuthorized = loginState === "authorized";
  const checkUserHistory = async () => {
    const data = await getUserChatHistories();
    if (data) {
      setIsViewHistory(!!data.length);
    }
  };

  useEffect(() => {
    if (isAuthorized && !isViewHistory) {
      checkUserHistory();
    }
  }, [loginState]);

  const data: IMoreHelpCard[] = [
    {
      title: t("chatWithUs"),
      detail: t("availableEveryday"),
      iconSrc: "/images/chat-with-us.svg",
      needAuthorized: false,
      type: "chat",
      onClick: (e) => {
        trackUserEvent(
          EVENT_TYPES.WEB_SUPPORT_HELP_CENTRE_CONTACT_LIVE_CHAT,
          {},
          [EVENT_CHANNELS.MIXPANEL]
        );
        autoStartChat(loginState, profile);
      },
    },
    {
      title: t("viewChatHistory"),
      detail: t("notSureWhatSupportSaid"),
      iconSrc: "/images/view-chat-history.svg",
      needAuthorized: true,
      href: "/chat-history",
      onClick: (e) => {
        trackUserEvent(
          EVENT_TYPES.WEB_SUPPORT_HELP_CENTRE_ACCESS_CHAT_HISTORY,
          {},
          [EVENT_CHANNELS.MIXPANEL]
        );
      },
    },
    {
      title: t("sendUsEmail"),
      detail: t("weWillGetBack"),
      iconSrc: "/images/send-us-email.svg",
      needAuthorized: false,
      href: "/email-us",
    },
    {
      title: t("shareUsFeedback"),
      detail: t("tellUsMore"),
      iconSrc: "/images/share-us-feedback.svg",
      needAuthorized: true,
      href: "/feedback",
    },
  ];

  return (
    <div className="md:border md:border-gray-500 md:rounded-xl p-5">
      <div className="flex justify-between items-center mb-5">
        <p className="font-semibold text-xl font-title">{t("needMoreHelp")}</p>
      </div>
      <div className="flex flex-col">
        {data
          .filter(
            (item) =>
              (item.needAuthorized && isAuthorized) || !item.needAuthorized
          )
          .map((item, idx) => (
            <div
              key={item.title}
              className={cn(
                "border-t border-gray-500 pt-4",
                idx !== data.length - 1 ? "pb-4" : ""
              )}
            >
              <MoreHelpCard {...item} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default FindMoreHelp;
